import { render } from "./MultipleChoiceType.vue?vue&type=template&id=e749684e"
import script from "./MultipleChoiceType.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceType.vue?vue&type=script&lang=js"

import exportComponent from "/Users/biwabits/Documents/ProjectDev/yayasan-ahmadyanibinjai/form-ppdb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__